<script setup>
import { useDesignSystem } from '@/composables/useDesignSystem'
import { addAndToString } from '@/plugins/misc'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  isPlatinum: {
    type: Boolean,
    default: false,
  },
  notPreferredNames: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue', 'continue'])

const { dialogWidth } = useDesignSystem()
const dWidth = dialogWidth(450)

const goBack = () => emit('update:modelValue', false)
const onContinue = () => emit('continue')
</script>

<template>
  <VDialog
    :model-value="modelValue"
    :width="dWidth"
    persistent
  >
    <VCard class=" text-center text-sm pa-2">
      <VCardText
        v-if="isPlatinum"
        class="pa-0"
      >
        <VCardItem class="px-0 py-2">
          <VIcon style="margin-left: -3px; margin-top: -3px;">
            iconamoon:certificate-badge-light
          </VIcon>{{ $t('reservation.validation.preferredInfo') }}
        </VCardItem>
        <VCardItem class="px-0 py-2">
          <b>{{ addAndToString(notPreferredNames.join(', ')) }}</b>{{ notPreferredNames.length > 1 ? ' ' + $t('reservation.preferred.areMemberFavorites') : ' ' + $t('reservation.preferred.isMemberFavorite') }}<br>
        </VCardItem>
        <VCardItem class="px-0 py-2">
          {{ $t('reservation.preferred.platinumCanRequest') }}<br>
          {{ $t('reservation.preferred.cantGuaranteeReview') }}
        </VCardItem>
      </VCardText>

      <VCardText
        v-else
        class="pa-0"
      >
        <VCardItem class="px-0 py-2">
          <VIcon style="margin-left: -3px; margin-top: -3px;">
            iconamoon:certificate-badge-light
          </VIcon>{{ $t('reservation.validation.preferredInfo') }}<br>
          {{ $t('reservation.preferred.premiumPlatinumCanRequest') }}
        </VCardItem>
        <VCardItem class="px-0 py-2">
          <b>{{ addAndToString(notPreferredNames.join(', ')) }}</b>{{ notPreferredNames.length > 1 ? ' ' + $t('reservation.preferred.areMemberFavorites') : ' ' + $t('reservation.preferred.isMemberFavorite') }}<br>
          {{ $t('reservation.preferred.platinumRequiredToRequest') }}
        </VCardItem>
      </VCardText>
      <VCardActions class="align-center justify-center gap-2 pt-2">
        <VBtn
          color="secondary"
          variant="tonal"
          @click="goBack"
        >
          {{ $t('reservation.actions.goBack') }}
        </VBtn>
        <VBtn
          variant="elevated"
          @click="onContinue"
        >
          {{ $t('reservation.actions.continue') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
